/** L'id HTML di un campo del modulo corsi: lo usano i campi e la pagina, per portare al primo errore. */
export function idCampo(campo: string): string {
  return `iscr-${campo}`;
}
